import { TProductRefId } from "@/types/plan";
import { TPlan } from "../types.checkout";

/**
 * Get available plans by filtering out currently active plans
 * Return product Object instead of just ids for easier handling in the UI
 */
export function getAvailablePlansToAdd(
  planCards: TPlan[],
  currentActivePlanIds: TProductRefId[],
): TPlan[] {
  // if (!currentActivePlanIds?.length) return [];
  return planCards.filter(
    (plan) => !currentActivePlanIds.includes(plan.productRefId),
  );
}
